require('./Channel.scss');

const b = require('app/www/libs/b')('channel-controller');
const bContent = require('app/www/libs/b')('content');

const _ = {
    get: require('lodash/get'),
    isEqual: require('lodash/isEqual'),
};
const React = require('react');
const PropTypes = require('prop-types');
const {connect} = require('react-redux');

const nextTick = require('app/www/libs/nextTick');

const {getEvent} = require('app/www/actions/event');
const {getSchedule} = require('app/www/actions/channel');

const Metrika = require('app/www/libs/client/metrika');

const {withReq} = require('app/www/components/contexts/Req');
const {withI18n} = require('app/www/components/contexts/I18n');
const {withExperiments} = require('app/www/components/contexts/Experiments');
const {update: updateReminders} = require('app/www/actions/reminders');
const {isADBEnabled} = require('app/www/libs/aab');

const AdvManager = require('app/www/components/blocks/AdvManager/AdvManager');
const AdInterScroller = require('app/www/components/blocks/AdInterScroller/AdInterScroller');
const AdFox = require('app/www/components/blocks/AdFox/AdFox');
const AdAboveInfo = require('app/www/components/blocks/AdAboveInfo/AdAboveInfo');
const Balloon = require('app/www/components/blocks/Balloon/Balloon');
const BreadCrumbs = require('app/www/components/blocks/BreadCrumbs/BreadCrumbs');
const Calendar = require('app/www/components/blocks/Calendar/Calendar');
const ChannelDescription = require('app/www/components/blocks/ChannelDescription/ChannelDescription');
const ChannelHeader = require('app/www/components/blocks/ChannelHeader/ChannelHeader');
const ChannelRecommended = require('app/www/components/blocks/ChannelRecommended/ChannelRecommended');
const ChannelSchedule = require('app/www/components/blocks/ChannelSchedule/ChannelSchedule');
const Content = require('app/www/components/blocks/Content/Content');
const Global = require('app/www/components/blocks/Global/Global');
const ResizeListener = require('app/www/components/blocks/ResizeListener/ResizeListener');
const Spin = require('app/www/components/blocks/Spin/Spin');
const Zen = require('app/www/components/blocks/Zen/Zen');
const Ua = require('app/www/components/blocks/Ua/Ua');

const {DESKTOP, TABLET, PHONE} = require('app/www/constants/devices');
const SCHEDULE_ITEM_LAST_INDEX = 3;
const EXPERIMENT_ZEN = 'zen_channel_program';
const EXPERIMENT_NAME_TO_HD = 'tv_channels_links_to_hd';

class ChannelController extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = Object.assign({
            fixed: 'top',
        }, Ua.displayWidth && (
            this._initialState
        ));

        this._recalculateScrollEdge = this._recalculateScrollEdge.bind(this);
        this._onChangeDate = this._onChangeDate.bind(this);
        this._onResize = this._onResize.bind(this);
        this._onStartEvent = this._onStartEvent.bind(this);
    }

    componentDidMount() {
        const {recommendedAll} = this.props;

        if (this._channelSchedule.items) {
            const {top, bottom, position} = this._scrollBounds;

            this._scroll = this._onScroll.bind(this, top, bottom, position);
            this._scroll();

            window.addEventListener('scroll', this._scroll);
        }

        Metrika.trackParams('CHANNEL_TYPES', recommendedAll.length > 0);

        this.setState({
            mounted: true,
        });

        nextTick(() => {
            this.setState(this._initialState);
        });
    }

    static getDerivedStateFromProps(props, state) {
        return state.scheduleLoading ? {
            scheduleLoading: false,
        } : null;
    }

    componentDidUpdate(prevProps) {
        const {schedule} = this.props;

        const isNewSchedule = !_.isEqual(prevProps.schedule, schedule);

        if (
            this._channelSchedule || isNewSchedule
        ) {
            this._recalculateScrollEdge();
        }

        if (isNewSchedule) {
            const reminders = [];
            _.get(schedule, 'events', []).forEach(event => {
                if (event.hasReminder) {
                    reminders.push(event.id);
                }
            });

            this.props.dispatchUpdateReminders(reminders);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this._scroll);
    }

    render() {
        const {
            req,
            i18n,
            store,
            event,
            channel,
            schedule,
            wannaSee,
            reminders,
            userLogged,
            experiments,
            currentEvent,
            recommendedAll,
            dispatchGetEvent,
            channelContentId,
        } = this.props;

        const {
            fixed,
            advKey,
            position,
            scheduleLoading,
            isLayoutColumnsSmall,
            isLayoutColumnsLarge,
        } = this.state;

        const selectedDate = req.query.date;
        const isSerpApp = req.lib('urlBuilder').isSerpApp;
        const isViewInIframeKinopoiskhd =
            req.lib('urlBuilder').isViewInIframeKinopoiskhd;
        const {
            id,
            logo,
            title,
            siteUrl,
            familyId,
            isFavorite,
            description,
            streamChannel,
            hasBroadcasting,
            hasBroadcastingPlayer,
        } = channel;

        const mods = {
            player: hasBroadcastingPlayer,
        };

        const hasHDLink = experiments.isExperiment(EXPERIMENT_NAME_TO_HD) || userLogged;

        const channelHeaderProps = {
            id,
            logo,
            title,
            familyId,
            hasHDLink,
            isFavorite,
            streamChannel,
            channelContentId,
            isLayoutColumnsSmall,
            isLayoutColumnsLarge,
            hasBroadcasting: !hasBroadcastingPlayer && hasBroadcasting,
        };

        const calendarProps = {
            mods: {
                channel: true,
            },
            isSimple: true,
            isChannel: true,
            selectedDate,
            isAsyncRouting: true,
            schedules: schedule.finish ? [schedule] : [],
            onChange: this._onChangeDate,
        };

        const channelScheduleProps = Object.assign({
            familyId,
            hasHDLink,
            currentEvent,
            channelContentId,
            isLayoutColumnsLarge,
            events: schedule.events,
            wannaSee: wannaSee.items,
            reminders: reminders.items,
            recommended: recommendedAll,
            hasFinished: schedule.hasFinished,
            onStartEvent: this._onStartEvent,
            onClickButton: this._recalculateScrollEdge,
        }, this.balloon && {
            onClick: this.balloon.onClickEvent,
            onMouseEnter: this.balloon.onMouseEnterEvent,
            onMouseLeave: this.balloon.onMouseLeaveEvent,
        });

        const balloonProps = {
            event,
            store,
            dispatchGetEvent,
        };

        const channelDescriptionProps = {
            text: description,
            siteUrl,
        };

        const channelRecommendedProps = {
            events: recommendedAll,
        };

        const advManagerAsideProps = {
            sticky: true,
            blockId: Global.adv.channel_aside_desktop,
        };

        const advManagerFooterProps = {
            blockId: Global.adv[`channel_footer_${isSerpApp ? 'serp_app' : advKey}`],
        };

        const advManagerFeedProps = {
            blockId: Global.adv.channel_phone_feed,
            isFeed: true,
        };

        const breadCrumbsProps = {
            items: [{title}],
        };

        const spinProps = {
            mods: {
                size: 'l',
            },
        };

        const resizeListenerProps = {
            callback: this._onResize,
        };

        const isExperimentZen = experiments.isExperiment(EXPERIMENT_ZEN) && Ua.isDesktop;

        let zenParams = {
            clid: 980,
            clid_name: 'zen_lib_tv_programma',
            lang: 'ru',
            uatraits: Ua.uatraits,
            apiName: 'launcher',
            product: 'zen_lib',
            partner: 'yandex',
            integration: 'zen_lib_tv_programma',
        };

        if (isADBEnabled(req)) {
            zenParams = Object.assign(zenParams, {
                host: 'https://main.zdevx.yandex.ru/',
                isAdblock: true,
            });
        }

        const AdFoxProps = Global.adFox.brandingChannels;

        const channelContent = (
            <div className={bContent('columns', {dark: isViewInIframeKinopoiskhd})}>
                <div className={bContent('main')}>
                    {!(isViewInIframeKinopoiskhd) && (
                        <div className={`${bContent('header')}`}>
                            <ChannelHeader {...channelHeaderProps} />
                        </div>
                    )}
                    <div
                        ref={(elem) => (this._schedule = elem)}
                        className={b('schedule', {dark: isViewInIframeKinopoiskhd})}
                    >
                        <div
                            ref={(elem) => (this._calendar = elem)}
                            className={b('calendar', { fixed, dark: isViewInIframeKinopoiskhd })}
                            style={{ top: position }}
                        >
                            <Calendar {...calendarProps} />
                        </div>
                        {scheduleLoading && (
                            <div className={b('loading')}>
                                <Spin {...spinProps} />
                            </div>
                        )}
                        {!scheduleLoading && (
                            <ChannelSchedule
                                ref={(elem) => (this._channelSchedule = elem)}
                                {...channelScheduleProps}
                            />
                        )}
                    </div>
                    {!isViewInIframeKinopoiskhd && (<div>
                        <AdAboveInfo />
                        <Balloon
                            ref={(elem) => (this.balloon = elem)}
                            {...balloonProps}
                        />
                        {(channel.description || channel.siteUrl) && (
                            <div className={b('description')}>
                                <div className={b('sub-title')}>
                                    {i18n.get('channel-controller.about')}
                                </div>
                                <ChannelDescription {...channelDescriptionProps} />
                            </div>
                        )}
                        {recommendedAll.length >= 1 && (
                            <div className={b('recommended')}>
                                <div className={b('sub-title')}>
                                    {i18n.get('channel-controller.recommended')}
                                </div>
                                <ChannelRecommended {...channelRecommendedProps} />
                            </div>
                        )}
                        {[TABLET, PHONE].includes(advKey) && (
                            <div className={bContent('adv-footer')}>
                                <AdInterScroller />
                                <AdvManager {...advManagerFeedProps} />
                            </div>
                        )}
                        {advKey === DESKTOP && (
                            <AdFox {...AdFoxProps} />
                        )}
                    </div>)}
                </div>
                <div
                    className={`${bContent('adv-aside')} ${b(
                        'adv-aside',
                        mods
                    )}`}
                >
                    {advKey === DESKTOP && (
                        <AdvManager {...advManagerAsideProps} />
                    )}
                </div>
            </div>
        );

        if (isViewInIframeKinopoiskhd) {
            return channelContent;
        }

        return (
            <Content className={bContent.mod({ channel: true })}>
                {channelContent}
                {advKey === DESKTOP && (
                    <div className={bContent('adv-footer')}>
                        <AdvManager {...advManagerFooterProps} />
                    </div>
                )}
                {isExperimentZen && <Zen params={zenParams} />}
                <BreadCrumbs {...breadCrumbsProps} />
                <ResizeListener {...resizeListenerProps} />
            </Content>
        );
    }

    /**
     * Получаем границы скролла и позиционирования календаря
     * @returns {Object}
     * @private
     */
    get _scrollBounds() {
        const item = this._channelSchedule.items[this._channelSchedule.items.length - SCHEDULE_ITEM_LAST_INDEX];
        const bottom = item ? item.getBoundingClientRect().top : this._schedule.getBoundingClientRect().bottom;
        const calendarHeight = this._calendar.offsetHeight;

        return {
            top: this._schedule.getBoundingClientRect().top + pageYOffset,
            bottom: bottom - calendarHeight + pageYOffset,
            position: item ? `${item.offsetTop}px` : `calc(100% - ${calendarHeight}px)`,
        };
    }

    /**
     * Позиционируем календарь при скролле
     * @private
     */
    _onScroll(top, bottom, position) {
        const {pageYOffset: scroll} = window;

        this.setState({
            fixed: scroll > bottom ? 'bottom'
            : scroll < top ? 'top' : 'page',
            position: scroll > bottom ? position : 0,
        });
    }

    /**
     * Пересчитываем границы скрола
     * @private
     */
    _recalculateScrollEdge() {
        window.removeEventListener('scroll', this._scroll);

        if (this._channelSchedule.items) {
            const {top, bottom, position} = this._scrollBounds;
            this._scroll = this._onScroll.bind(this, top, bottom, position);
            window.addEventListener('scroll', this._scroll);
        }
    }

    /**
     * @private
     * @param {String} title
     */
    _onStartEvent(title) {
        this.setState({
            startedEventTitle: title,
        });
    }

    /**
     * Поменялась дата в календаре
     * @param {Object} query
     * @private
     */
    _onChangeDate(evt, query) {
        evt.preventDefault();

        this.setState({
            scheduleLoading: true,
        });

        this.props.dispatchGetSchedule(this.props.channel.transliteratedFamilyTitle, query);
    }

    /**
     * @returns {Object}
     */
    get _initialState() {
        return {
            isTouchButtons: Ua.isTouchButtons,
            isLayoutColumnsSmall: Ua.isLayoutColumnsSmall,
            isLayoutColumnsLarge: Ua.isLayoutColumnsLarge,
            advKey: Ua.isLayoutColumnsSmall ? PHONE :
                Ua.isLayoutColumnsLarge ? TABLET : DESKTOP,
        };
    }

    /**
     * @private
     */
    _onResize() {
        this.setState({
            isTouchButtons: Ua.isTouchButtons,
            isLayoutColumnsSmall: Ua.isLayoutColumnsSmall,
            isLayoutColumnsLarge: Ua.isLayoutColumnsLarge,
        });
    }
}

ChannelController.propTypes = {
    channel: PropTypes.object,
};

function mapStateToProps(state) {
    return {
        channel: state.channel.channel,
        schedule: state.channel.schedule,
        recommendedAll: state.recommendedAll,
        event: _.get(state, 'event.item'),
        wannaSee: state.wannaSee,
        reminders: state.reminders,
        channelContentId: state.channel.channelContentId,
        currentEvent: state.channel.currentEvent,
        userLogged: state.user.isLogged,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatchGetEvent: (eventId, programCoId) => dispatch(getEvent(eventId, programCoId)),
        dispatchGetSchedule: (channelId, selectedDay) => dispatch(getSchedule(channelId, selectedDay)),
        dispatchUpdateReminders: eventIds => dispatch(updateReminders(eventIds)),
    };
}

module.exports = connect(
    mapStateToProps,
    mapDispatchToProps
)(
    withReq(withI18n(withExperiments(
        ChannelController
    )))
);
